import { useState, useEffect } from 'react';
const useIndexedData = function (hashTable) {
  let indices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let treeNodes = arguments.length > 2 ? arguments[2] : undefined;
  const [indexedItems, setIndexedItems] = useState(treeNodes);
  useEffect(() => {
    if (indices.length > 0) {
      const result = [];
      const idToBeIndexed = indices.at(-1);
      const childRecords = hashTable.get(idToBeIndexed)?.children || [];
      result.push(...childRecords);
      setIndexedItems(result);
    } else {
      setIndexedItems(treeNodes);
    }
  }, [indices, hashTable, treeNodes]);
  return {
    indexedItems
  };
};
export default useIndexedData;